import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Observable } from 'relay-runtime';
import { getClient, getSinkError } from '@atlassian/graphql-subscription';
var cachedDefaultSubscribe;
export function createSubscribeFn(subscribeOptions) {
  if (typeof subscribeOptions === 'undefined' && typeof cachedDefaultSubscribe !== 'undefined') {
    return cachedDefaultSubscribe;
  }
  var fn = function fn(_ref, variables, cacheConfig) {
    var id = _ref.id,
      operationName = _ref.name;
    return Observable.create(function (sink) {
      var _cacheConfig$metadata, _subscribeOptions$onS;
      var client = getClient();
      if (!client) {
        return sink.error(new Error('Unable to create subscription client'));
      }
      var replayConfig = (cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.replay) || undefined;
      var payload = {
        query: '',
        operationName: operationName,
        variables: variables,
        extensions: _objectSpread(_objectSpread({
          pq: id
        }, (subscribeOptions === null || subscribeOptions === void 0 ? void 0 : subscribeOptions.subscribeExtensions) || {}), replayConfig && {
          replay: replayConfig
        })
      };
      var requestId = null;
      subscribeOptions === null || subscribeOptions === void 0 || (_subscribeOptions$onS = subscribeOptions.onSubscribeTrigger) === null || _subscribeOptions$onS === void 0 || _subscribeOptions$onS.call(subscribeOptions, payload);
      return client.subscribe(payload, _objectSpread(_objectSpread({}, sink), {}, {
        next: function next(value) {
          var _value$extensions;
          // @ts-expect-error agg prop is missing on generic "extensions" type
          var aggRequestId = value === null || value === void 0 || (_value$extensions = value.extensions) === null || _value$extensions === void 0 || (_value$extensions = _value$extensions.gateway) === null || _value$extensions === void 0 ? void 0 : _value$extensions.request_id;
          requestId = aggRequestId !== null && aggRequestId !== void 0 ? aggRequestId : requestId;
          // @ts-expect-error incompatible types between two libraries
          sink.next(value);
        },
        error: function error(sinkError) {
          var _subscribeOptions$onS2;
          var errorInfo = getSinkError(sinkError);
          sink.error(errorInfo);
          subscribeOptions === null || subscribeOptions === void 0 || (_subscribeOptions$onS2 = subscribeOptions.onSubscribeError) === null || _subscribeOptions$onS2 === void 0 || _subscribeOptions$onS2.call(subscribeOptions, _objectSpread(_objectSpread({}, payload), {}, {
            requestId: requestId
          }));
        }
      }));
    });
  };
  if (typeof subscribeOptions === 'undefined') {
    cachedDefaultSubscribe = fn;
  }
  return fn;
}
export var subscribe = createSubscribeFn();